import { useEffect, useState } from "react";
import { proxyStorage } from "../../../../utils/proxyStorage";
import { useParams } from "react-router";

export const TranslateLabels: any = {
	vi: {
		HOME_PAGE: "Trang chủ",
		DEBT_MANAGEMENT_TITLE: "Whalelo Admin – Quản lý công nợ",
		DEBT_BREADCRUMB_HOME: "Home",
		DEBT_BREADCRUMB_ADMIN: "Admin",
		DEBT_BREADCRUMB_MANAGEMENT: "Quản lý công nợ",
		DEBT_WAITING_STATION: "Chờ Station xác nhận",
		DEBT_WAITING_ADMIN: "Chờ Admin duyệt",
		DEBT_DISPUTED: "Đang thỏa thuận",
		DEBT_WAITING_PAYMENT: "Chờ thanh toán",
		DEBT_ADJUSTMENTS: "điều chỉnh",
		DEBT_BOOKINGS: "booking",
		DEBT_LIST_TITLE: "Danh sách công nợ",
		DEBT_SEARCH_HISTORY: "Tra cứu dữ liệu lịch sử",
		DEBT_EXPORT: "Export",
		DEBT_SEARCH_PLACEHOLDER: "Tìm station",
		DEBT_SELECT_REGION: "Chọn khu vực",
		DEBT_ALL_STATUS: "Tất cả trạng thái",
		DEBT_STATUS_WAITING: "Chờ Station",
		DEBT_STATUS_DISPUTED: "Đang tranh chấp",
		DEBT_STATUS_CONFIRMED: "Đã xác nhận",
		DEBT_STATUS_PAID: "Đã thanh toán",
		DEBT_FILTER: "Lọc",
		DEBT_REMOVE_NON_DEBT: "Loại bỏ không phát sinh công nợ",
		DEBT_PARTNERS: "đối tác",
		DEBT_APPROVE_SELECTED: "✓ Duyệt đã chọn",
		DEBT_CANCEL_SELECTED: "✕ Hủy đã chọn",
		DEBT_PARTNER_STATION: "Partner/Station",
		DEBT_PERIOD: "KỲ",
		DEBT_AMOUNT: "SỐ TIỀN (Tiền tệ)",
		DEBT_BOOKING_COUNT: "SỐ BOOKING",
		DEBT_STATUS: "TRẠNG THÁI",
		DEBT_NEEDS_PROCESSING: "CẦN XỬ LÝ",
		DEBT_APPROVE: "DUYỆT",
		DEBT_DETAILS: "CHI TIẾT",
		DEBT_ACCEPT: "Chấp nhận",
		DEBT_DETAIL: "Chi tiết",
		DEBT_LOADING: "Đang tải dữ liệu...",
		DEBT_NO_DATA: "Không có dữ liệu",
	},
	en: {
		HOME_PAGE: "Home",
		DEBT_MANAGEMENT_TITLE: "Whalelo Admin – Debt Management",
		DEBT_BREADCRUMB_HOME: "Home",
		DEBT_BREADCRUMB_ADMIN: "Admin",
		DEBT_BREADCRUMB_MANAGEMENT: "Debt Management",
		DEBT_WAITING_STATION: "Waiting for Station",
		DEBT_WAITING_ADMIN: "Waiting for Admin",
		DEBT_DISPUTED: "Under Dispute",
		DEBT_WAITING_PAYMENT: "Waiting for Payment",
		DEBT_ADJUSTMENTS: "adjustments",
		DEBT_BOOKINGS: "booking",
		DEBT_LIST_TITLE: "Debt List",
		DEBT_SEARCH_HISTORY: "Search History",
		DEBT_EXPORT: "Export",
		DEBT_SEARCH_PLACEHOLDER: "Search station",
		DEBT_SELECT_REGION: "Select Region",
		DEBT_ALL_STATUS: "All Status",
		DEBT_STATUS_WAITING: "Waiting for Station",
		DEBT_STATUS_DISPUTED: "Under Dispute",
		DEBT_STATUS_CONFIRMED: "Confirmed",
		DEBT_STATUS_PAID: "Paid",
		DEBT_FILTER: "Filter",
		DEBT_REMOVE_NON_DEBT: "Remove non-debt stations",
		DEBT_PARTNERS: "partners",
		DEBT_APPROVE_SELECTED: "✓ Approve Selected",
		DEBT_CANCEL_SELECTED: "✕ Cancel Selected",
		DEBT_PARTNER_STATION: "Partner/Station",
		DEBT_PERIOD: "PERIOD",
		DEBT_AMOUNT: "AMOUNT (Currency)",
		DEBT_BOOKING_COUNT: "BOOKINGS",
		DEBT_STATUS: "STATUS",
		DEBT_NEEDS_PROCESSING: "NEEDS PROCESSING",
		DEBT_APPROVE: "APPROVE",
		DEBT_DETAILS: "DETAILS",
		DEBT_ACCEPT: "Accept",
		DEBT_DETAIL: "Details",
		DEBT_LOADING: "Loading data...",
		DEBT_NO_DATA: "No data available",
	},
	kr: {
		HOME_PAGE: "홈페이지",
		DEBT_MANAGEMENT_TITLE: "Whalelo Admin – 채권 관리",
		DEBT_BREADCRUMB_HOME: "홈",
		DEBT_BREADCRUMB_ADMIN: "관리자",
		DEBT_BREADCRUMB_MANAGEMENT: "채권 관리",
		DEBT_WAITING_STATION: "역 대기 중",
		DEBT_WAITING_ADMIN: "관리자 대기 중",
		DEBT_DISPUTED: "분쟁 중",
		DEBT_WAITING_PAYMENT: "결제 대기 중",
		DEBT_ADJUSTMENTS: "조정",
		DEBT_BOOKINGS: "예약",
		DEBT_LIST_TITLE: "채권 목록",
		DEBT_SEARCH_HISTORY: "검색 이력",
		DEBT_EXPORT: "내보내기",
		DEBT_SEARCH_PLACEHOLDER: "파트너, 역 검색",
		DEBT_SELECT_REGION: "지역 선택",
		DEBT_ALL_STATUS: "모든 상태",
		DEBT_STATUS_WAITING: "역 대기 중",
		DEBT_STATUS_DISPUTED: "분쟁 중",
		DEBT_STATUS_CONFIRMED: "확인됨",
		DEBT_STATUS_PAID: "지불됨",
		DEBT_FILTER: "필터",
		DEBT_REMOVE_NON_DEBT: "비채권 파트너 제거",
		DEBT_PARTNERS: "파트너",
		DEBT_APPROVE_SELECTED: "✓ 선택한 항목 승인",
		DEBT_CANCEL_SELECTED: "✕ 선택한 항목 취소",
		DEBT_PARTNER_STATION: "파트너/역",
		DEBT_PERIOD: "기간",
		DEBT_AMOUNT: "금액 (통화)",
		DEBT_BOOKING_COUNT: "예약 수",
		DEBT_STATUS: "상태",
		DEBT_NEEDS_PROCESSING: "처리 필요",
		DEBT_APPROVE: "승인",
		DEBT_DETAILS: "상세",
		DEBT_ACCEPT: "수락",
		DEBT_DETAIL: "상세",
		DEBT_LOADING: "데이터 로딩 중...",
		DEBT_NO_DATA: "데이터 없음",
	},
};

export function useLanguage() {
	const defaultLang = "vi";
	const { lang } = useParams<{ lang: string }>();
	const [selectedLang, setSelectedLang] = useState(lang || defaultLang);

	useEffect(() => {
		setSelectedLang(lang || defaultLang);
	}, [lang]);

	const languageOptions = [
		{
			code: "en",
			name: "English",
			nameRes: "EN",
			img: "./static/img/ImgLangEn.png",
			imgRes: "./static/img/ImgLangEn.png",
		},
		{
			code: "vi",
			name: "Tiếng Việt",
			nameRes: "VI",
			img: "./static/img/ImgLangEn.png",
			imgRes: "./static/img/ImgLangEn.png",
		},
		// { code: "kr", name: "한국어",nameRes: "KR", img: "./static/img/ImgLangEn.png", imgRes: "./static/img/ImgLangEn.png" },
	];

	const onLangChange = (value: any) => {
		setSelectedLang(value);
	};

	return { lang: selectedLang || "vi", setLang: onLangChange, languageOptions };
}
